export const CrisisNote = ({ testId = "crisis-note" }) => (
  <p data-testid={testId} className="text-[13px] leading-relaxed text-sec">
    Si estás pasando por un momento muy difícil, la <strong className="font-semibold text-tinta">Línea de la Vida</strong> atiende gratis las 24 horas:{" "}
    <a href="tel:8009112000" className="font-semibold text-tinta hover:underline underline-offset-2">800 911 2000</a>.
    Si hay peligro inmediato, llama al{" "}
    <a href="tel:911" className="font-semibold text-tinta hover:underline underline-offset-2">911</a>.
  </p>
);
